var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_544_20971",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.417969,
    y: 0.239746,
    width: 19.5607,
    height: 19.5607,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_544_20971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.92841 16.1326C3.51671 16.1326 3.16823 15.99 2.88297 15.7047C2.59771 15.4195 2.45508 15.071 2.45508 14.6593V5.38056C2.45508 4.96886 2.59771 4.62038 2.88297 4.33512C3.16823 4.04986 3.51671 3.90723 3.92841 3.90723H16.4673C16.879 3.90723 17.2274 4.04986 17.5127 4.33512C17.798 4.62038 17.9406 4.96886 17.9406 5.38056V14.6593C17.9406 15.071 17.798 15.4195 17.5127 15.7047C17.2274 15.99 16.879 16.1326 16.4673 16.1326H3.92841ZM10.1978 10.4744L16.7181 6.30525L16.5927 5.12975L10.1978 9.20489L3.80299 5.12975L3.6776 6.30525L10.1978 10.4744Z",
    fill: "#6842D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.555278f9f52576b9b85b0951aa17129f.svg";
export { ForwardRef as ReactComponent };